import { render, staticRenderFns } from "./partnerBranchAddressBox.vue?vue&type=template&id=15204aec&"
import script from "./partnerBranchAddressBox.vue?vue&type=script&lang=ts&"
export * from "./partnerBranchAddressBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports